import { base64ArrayBuffer } from '~/lib/base64';
import { salePrint } from '~/apps/pos/apis/message';


export async function getStarPrintUrl(pdfUrl: string, absReturnUrl: string): Promise<string> {
  const req = await fetch(pdfUrl);
  const buf = await req.arrayBuffer();
  const encoded = encodeURIComponent(base64ArrayBuffer(buf));
  return `starpassprnt://v1/print/nopreview?pdf=${encoded}&back=${encodeURIComponent(absReturnUrl)}`;
}

export async function getStarPrintPdf(saleId: string, absReturnUrl: string): Promise<string> {
  const req = await salePrint(saleId);
  const buf = await req.arrayBuffer();
  const encoded = encodeURIComponent(base64ArrayBuffer(buf));
 return `starpassprnt://v1/print/nopreview?pdf=${encoded}&back=${encodeURIComponent(absReturnUrl)}`;
}
